// @flow
import client from '../../client'

// Types
export type Options = {
  search_id: string,
  useful: boolean,
}

// API Endpoints
export const RECOMMENDED_FEEDBACK_ENDPOINT = '/recommendations/useful/'

/**
 * Gives feedback on whether the recommended trip was useful or not.
 * @param  {Object} data Trip search data
 * @param  {string} data.session_id Trip search session ID.
 * @param  {boolean} data.useful Whether the recommended trip was useful.
 * @return {Promise|Error} An empty resolved Promise or Rejected with an Error.
 */
export const wasRecommendationUseful = (data: Options): Promise<any> =>
  client.post(RECOMMENDED_FEEDBACK_ENDPOINT, { body: data })

export default wasRecommendationUseful
